import VueMonthlyPicker from 'vue-monthly-picker'
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import store from '@/store';
import moment from "moment";

export default {
  name: "teacherMonthlyAttendance",
  components: {
    MainLayout,
    VueMonthlyPicker,
    Loading,
  },

  data() {
    return {
      monthlyAttendanceList: [],
      lastSearchParams: {},
      academicYearArr: [],
      daysInMonth: [],
      selectedMonth: moment().format('YYYY-MM'),
      searchMonth: moment().format('YYYY-MM'),
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      holidays : [],
    };
  },

  methods: {
    getDaysInMonth() {
      if (!this.searchMonth) return [];

      const dateContext = moment(this.searchMonth, 'YYYY-MM');
      const daysCount = dateContext.daysInMonth();
      
      this.daysInMonth = Array.from({ length: daysCount }, (_, i) => i + 1)
      .filter(day => {
        const date = dateContext.clone().date(day).format('YYYY-MM-DD');
        return !this.holidays.includes(date);
      });
    },

    reset() {
      this.selectedMonth = moment().format("YYYY-MM");
      this.getMonthlyAttendanceList();
    },

    getStatusBg(attendanceList, day) {
      const cellDate = moment(`${this.searchMonth}-${String(day).padStart(2, '0')}`, 'YYYY-MM-DD');
      const today = moment().startOf('day');

      if (cellDate.isSameOrAfter(today)) {
        return 'bg-gray';
      }
      const record = attendanceList.find(r => {
        return new Date(r.date).getDate() === day;
      });
      const status = record ? record.is_present : 'default';
      return CONFIG.ATTENDANCE_STATUS_COLOR[status] || 'bg-gray';
    },

    getMonthlyAttendanceList(page = 1) {
      if (!this.selectedMonth) {
        this.selectedMonth = moment().format('YYYY-MM');
      }
      const monthStr = moment(this.selectedMonth).format('YYYY-MM');
      this.isLoading = true;
      const params = {
        campus_id: store.state.user.campus_id,
        month: monthStr,
        is_paginate: true,
      }
      axios.get("/monthly/attendance/history?page=" + page , { params })
        .then(response => {
          this.searchMonth = monthStr;
          this.monthlyAttendanceList = response.data.data;
          this.holidays = response.data.holidays || [];
          this.getDaysInMonth();
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Monthly Attendance List API Error", error);
        });
    },

    getWeekDay(day) {
      if (!this.searchMonth) return '';
      return moment(
        `${this.searchMonth}-${String(day).padStart(2, '0')}`,
        'YYYY-MM-DD'
      ).format('ddd');
    },

    getYears() {
      const currentYear = moment().year();
      const startYear = currentYear - 5;
      const endYear = currentYear + 1;

      this.academicYearArr = [
        { id: null, text: 'Select Year' },
        ...Array.from({ length: endYear - startYear + 1 }, (_, i) => {
          const year = startYear + i;
          return { id: year, text: year.toString() };
        })
      ];
    },
  },

  computed: {
    monthDateRange() {
      if (!this.searchMonth) return '';

      const startOfMonth = moment(this.searchMonth).startOf('month');
      const endOfMonth = moment(this.searchMonth).endOf('month');

      return `${startOfMonth.format('D/M/YYYY')} ~ ${endOfMonth.format('D/M/YYYY')}`;
    }
  },

  mounted() {
    this.isLoading = true;
    this.getYears();
    this.getMonthlyAttendanceList();
  },
};
